import Api from 'utils/ApiRequest';
import API_URL from 'constants/api';
import { actionSet } from './utils';
import { getPages } from 'component/pagination/utils';
import { FETCH_PRICE_AUDIT_REPORT_REQUEST, FETCH_PRICE_AUDIT_REPORT_SUCCESS, FETCH_PRICE_AUDIT_REPORT_ERROR, FETCH_SUPPLY_POSITIONS_NOT_COUNTED_SUCCESS, FETCH_SUPPLY_POSITIONS_NOT_COUNTED_ERROR, FETCH_SUPPLY_HISTORY_COUNT_SUCCESS, FETCH_SUPPLY_HISTORY_COUNT_ERROR, } from 'actionTypes';
import { hideSpinner, showSpinner } from './spinner';
import { PriceAuditType } from 'utils/Enums';
import moment from 'moment';
export var priceAuditTypeFromStatusCode = function (statusCode) { return PriceAuditType[statusCode - 1]; };
export var fetchHistoryCount = function (token, param, callback, signalController) { return function (dispatch) {
    param.dtStart = moment(param.dtStart).format('L');
    param.dtEnd = moment(param.dtEnd).format("L");
    param.cdLm = Array.isArray(param.dsLdaps) && param.dsLdaps.length > 0 ? param.dsLdaps[0] : "";
    var onClose = function () {
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    var onError = function (error) {
        dispatch(actionSet(FETCH_SUPPLY_HISTORY_COUNT_ERROR, error));
        onClose();
    };
    var onMessage = function (response) {
        dispatch(getPages(response.data.pages));
        dispatch(actionSet(FETCH_SUPPLY_HISTORY_COUNT_SUCCESS, response.data.reportList));
        if (callback) {
            callback(response.data.reportList, response.data.pages.totalCount);
        }
        onClose();
    };
    var abort = function () {
        signalController.abort();
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    dispatch(showSpinner("", true, abort));
    return new Api(token, dispatch)
        .eventSourceStream(API_URL.FETCH_SUPPLY_HISTORY_COUNT, param, null, signalController, onMessage, onClose, onError)
        .catch(function (error) { return onError(error); });
}; };
export var fetchFlux = function (token, param, callback, signalController) { return function (dispatch) {
    param.dtStart = moment(param.dtStart).format("L");
    param.dtEnd = moment(param.dtEnd).format("L");
    param.cdLm = Array.isArray(param.dsLdaps) && param.dsLdaps.length > 0 ? param.dsLdaps[0] : "";
    var onClose = function () {
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    var onError = function (error) {
        dispatch(actionSet(FETCH_SUPPLY_POSITIONS_NOT_COUNTED_ERROR, error));
        onClose();
    };
    var onMessage = function (response) {
        dispatch(getPages(response.data.pages));
        dispatch(actionSet(FETCH_SUPPLY_POSITIONS_NOT_COUNTED_SUCCESS, response.data.reportList));
        if (callback) {
            callback(response.data.reportList, response.data.pages.totalCount);
        }
        onClose();
    };
    var abort = function () {
        signalController.abort();
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    dispatch(showSpinner("", true, abort));
    return new Api(token, dispatch)
        .eventSourceStream(API_URL.FETCH_POSITIONS_NOT_COUNTED, param, null, signalController, onMessage, onClose, onError)
        .catch(function (error) { return onError(error); });
}; };
export var fetch = function (token, param, callback) { return function (dispatch) {
    param.priceAuditType = priceAuditTypeFromStatusCode(param.priceAuditTypeCode);
    param.dtStart = moment(param.dtStart).format('L');
    param.dtEnd = moment(param.dtEnd).format("L");
    dispatch(actionSet(FETCH_PRICE_AUDIT_REPORT_REQUEST));
    return new Api(token, dispatch)
        .post(API_URL.FETCH_PRICE_AUDIT, param)
        .then(function (response) {
        dispatch(getPages(response.data.pages));
        dispatch(actionSet(FETCH_PRICE_AUDIT_REPORT_SUCCESS, response.data.priceAuditReport));
        if (callback) {
            callback(response.data.priceAuditReport, response.data.pages.totalCount, { sections: response.data.priceAuditChartSections, stores: response.data.priceAuditChartStores });
        }
    })
        .catch(function (error) {
        dispatch(actionSet(FETCH_PRICE_AUDIT_REPORT_ERROR, error));
        dispatch(hideSpinner());
    })
        .finally(function () { });
}; };
